<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">List Users</div>
                <button type="button" id='exportUsers' class="btn btn-primary ml-1 pull-right"
                        v-on:click="exportUsersData($event)">
                    Export
                </button>
                <button type="submit" v-on:click.prevent="gotoDraggableHRList" class="btn btn-primary waves-effect pull-right">HR Team List</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                    <!-- List Content Here -->
                    <vue-good-table
                        ref="hrteamList"
                        mode="remote"
                        title="List User"
                        @on-page-change="onPageChange"
                        @on-selected-rows-change="selectionChanged"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                        }"
                        :selectOptions="{
                        enabled: true,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                        }"

                        :search-options="{
                        enabled: false,
                        }">

                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <!--class="btn btn-xs btn-primary"-->
                                <div v-if="props.column.field == 'action'" class="table-action">
                                    <router-link title='Edit User' class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'AddUpdateUsers',params:{id:props.row.id}}"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>
                                    <template v-if="loginUserId != props.row.id">
                                        <a title='Delete User' id="delete" class="btn edit-btn-vvg waves-effect"  v-on:click.prevent="deleteHrTeam(props.row.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                                    </template>
                                   <template v-if="loginUserId != props.row.id">
                                        <template v-if="props.row.is_active">
                                            <a v-on:click="changeActiveInactiveStatus(props.row.id, 'Deactive')" class="btn edit-btn-vvg waves-effect" title="Make Deactive">
                                                <i class="fa fa-eye-slash" aria-hidden="true"></i>
                                            </a>
                                        </template>
                                        <template v-else>
                                            <a v-on:click="changeActiveInactiveStatus(props.row.id, 'Active')" class="btn edit-btn-vvg waves-effect" title="Make Active">
                                                <i class="fa fa-eye" aria-hidden="true"></i>
                                            </a>
                                        </template>
                                    </template>
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>

                        <div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <button data-toggle="modal" title='Send mail to all' class="btn btn-primary" v-on:click.prevent="loadModel('btnsendmailall')" >Send Mail To All {{totalRecords}}</button>
                            <button data-toggle="modal" title='Send mail to selected' class="btn btn-primary" v-on:click.prevent="loadModel('btnsendmail')" >Send Mail To Selected</button>
                            <button id="deleteMultiple" class="btn btn-primary" v-on:click.prevent="deleteHrTeam()">Delete User ({{selectedRows}})</button>
                           <button v-on:click="changeActiveInactiveStatus(0, 'Active')" class="btn btn-success" title="Make Active">Active ({{selectedRows}})</button>
                            <button v-on:click="changeActiveInactiveStatus(0, 'Deactive')" class="btn btn-danger" title="Make Deactive">Deactive ({{selectedRows}})</button> 
                        </div>

                    </vue-good-table>
                </div>
                <div class="modal fade" id="queueEmail" style="opacity: 1;" tabindex="-1" role="dialog">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <form id="emailNotification" method="POST" enctype="multipart/form-data">
                                <div class="modal-header">
                                    <h4 class="modal-title" id="defaultModalLabel">{{modelTitle}}</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Subject</label>
                                            <input id='subject' v-model="subject" class="form-control" type="text" placeholder="Subject" />
                                            <font class="text-danger">{{subjectError}}</font>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Message</label>
                                            <textarea id='message' v-model="message" class="form-control" placeholder="Write Message"></textarea>
                                            <font class="text-danger">{{messageError}}</font>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Attachment</label>
                                            <input type="file" name="excl_file" id="upload" ref="filesAttachment" v-on:change="handleFilesUploadAttachment()"/>
                                        </div>
                                    </div>
                                    <!--Error Alert-->
                                    <div class="col-md-12">
                                        <div class="alert alert-danger" id="alertError">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <strong id="errorMsg" class="error"></strong>
                                        </div>
                                    </div>
                                    <!--<div class="modal-footer">-->
                                    <div class="col-md-12 mb-4">
                                        <button type="button" :id='modelButtonId' v-on:click="sendMail($event)" class="btn btn-primary">Send Notification</button>
                                        <!--<button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>-->
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';

    var self;
    export default {
        name: 'ListDiscounts',
        components: {
            'app-backend-footer': BackendFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                loginUserId: 0,
                error: '',
                exportUsers: false,
                modelTitle: '',
                modelButtonId: '',
                subject: '',
                subjectError: '',
                message: '',
                messageError: '',
                filesAttachment: [],
                firstLoad: 0,
                columns: [
//                    {
//                        label: 'ID',
//                        field: 'id',
//                        filterable: true,
//                        filterOptions: {
//                            enabled: true, // enable filter for this column
//                            placeholder: "ID", // placeholder for filter input
//                            filterValue: '', // initial populated value for this filter
//                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
//                            filterFn: this.onColumnFilter, //custom filter function that
//                            trigger: "enter" //only trigger on enter not on keyup
//                        }
//                    },
                    {
                        label: 'First Name',
                        field: 'first_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "First Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Last Name',
                        field: 'last_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Last Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Reporting To',
                        field: 'reporting_to',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Reporting To", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Email',
                        field: 'email',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Email", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'DayForce Id',
                        field: 'username',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "DayForce Id", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Designation',
                        field: 'role',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Role", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'State',
                        field: 'location',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "State", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Location',
                        field: 'site_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Department',
                        field: 'department_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Department", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Status',
                        field: 'status',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Status", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: ['Active', 'Deactive'], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Last Login',
                        field: 'last_login',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Last Login", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            //self.checkLogin();
        },
        mounted: function () {
            self.showLoader();
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserId = userJson['id'];
            }
            $("#subject").on('keyup', function () {
                self.subjectError = '';
            });
            $("#message").on('keyup', function () {
                self.messageError = '';
            });
//            self = this;
            $("#alertError").hide();
            self.loadHRTeam();
        },
        methods: {
            changeActiveInactiveStatus: function (id, state) {
                var use = [];
                if(id == 0) {
                    var data = this.$refs['hrteamList'].selectedRows;
                    for (var i = 0; i < data.length; i++) {
                        use.push(this.$refs['hrteamList'].selectedRows[i].id)
                    }

                }
                self.$swal({
                    title: '',
                    text: 'Are you sure that you want to ' + state + ' this User!',
                    type: 'info',
                    confirmButtonText: 'OK',
                    showCancelButton: true,
                    // showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        var fields = {
                            id: (id != 0) ? id : use,
                            state: state,
                            flag: (id != 0) ? 'oneByOne' : 'all'
                        };
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        };
                        self.showLoader();
                        HTTP.post("activeordeative", fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    self.loadHRTeam();
                                }
                                self.hideLoader();
                            })
                            .catch(function (error) {
                                self.hideLoader();
                                self.catchHandler(error, function () {});
                            });
                    }
                });
            },
            checkForm: function () {
                var checked = true;

                if (!self.subject) {
                    self.subjectError = "Subject Is Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.message) {
                    self.messageError = "Email Message Is Required";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            gotoDraggableHRList() {
                self.$router.push('/backend/hrdragview');
            },

            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadHRTeam();
            },
            //
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadHRTeam();
                }
            },

            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('first_name');
                    field: ('last_name');
                    field: ('reporting_to');
                    field: ('email');
                    field: ('username');
                    field: ('role');
                    field: ('location');
                    field: ('status');
                    field: ('last_login');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.id || filters.first_name || filters.last_name || filters.reporting_to || filters.email || filters.username || filters.role || filters.location || filters.status || filters.last_login) {
                    self.loadHRTeam();
                }

            },
            selectionChanged() {
                self.selectedRows = (self.$refs['hrteamList'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadHRTeam();
            },
            deleteHrTeam: function (id) {
                var usedArr = [];
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                if (id) {
                    usedArr.push(id);
                } else {
                    var selectedUser = self.$refs['hrteamList'].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        usedArr.push(self.$refs['hrteamList'].selectedRows[i].id);
                    }
                }
                var fields = {
                    deleteArr: usedArr,
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post("deleteuser", fields, config)
                                .then(function (response) {
                                    self.loadHRTeam();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal('Deleted', 'You successfully deleted the record(s).', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your record(s) still intact', 'info')
                    }
                });
            },
            loadModel: function (action) {
                self.modelTitle = 'Send Email Notification To Selected';
                if (action == 'btnsendmailall') {
                    self.modelTitle = 'Send Email Notification To All';
                }
                self.modelButtonId = action;
                $('#queueEmail').modal('show');
            },
            sendMail: function (e) {
                $("#alertError").hide();
                self.checkForm();
                if (self.checkForm()) {
                    $(e.target).text('Sending...');
                    $(e.target).prop("disabled", true);

                    var selectedCustomers = self.$refs['hrteamList'].selectedRows;
                    var usersArr = [];
                    for (var i = 0; i < selectedCustomers.length; i++) {
                        usersArr.push(self.$refs['hrteamList'].selectedRows[i].id);
                    }
                    self.firstLoad = 1;
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var fields = new FormData();
                    fields.append('subject', self.subject);
                    fields.append('message', self.message);
                    fields.append('filters', JSON.stringify(self.serverParams.columnFilters));
                    fields.append('sort', JSON.stringify(self.serverParams.sort));
                    fields.append('users_arr', usersArr);
                    fields.append('send_email', e.target.id);
                    for (var i = 0; i < self.filesAttachment.length; i++) {
                        let file = self.filesAttachment[0];
                        fields.append('attachment', file);
                    }
                    this.$swal({
                        title: 'Are you sure?',
                        text: 'You want to send email notification',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes Send it!',
                        cancelButtonText: 'No, Don\'t send it!',
                        showCloseButton: true,
                        showLoaderOnConfirm: true
                    }).then((result) => {
                        if (result.value) {
                            self.showLoader();
                            HTTP.post('sendemail', fields, config)
                                    .then(function (response) {
                                        $(e.target).text('Send Notification');
                                        $(e.target).prop("disabled", false);

                                        if (response.data.code == '200') {
                                            self.subject = '';
                                            self.message = '';
                                            self.filesAttachment = [];
                                            $('#upload').val('');
                                            $('#queueEmail').modal('hide');
                                            self.$swal({
                                                type: 'success',
                                                text: 'Email Notification Sent Successfully',
                                                showConfirmButton: false,
                                                timer: 5000,
                                            });
                                            self.loadHRTeam();
                                        }
                                        self.hideLoader();
                                    })
                                    .catch(function (err) {
                                        $(e.target).text('Send Notification');
                                        $(e.target).prop("disabled", false);
                                        //$('#queueEmail').modal('hide');
                                        if (err.response.status == 0) {
                                            self.error = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                self.$router.push("/login");
                                                //EventBus.$emit("logged-in", true, "", "");
                                            } else {
                                                $("#alertError").show();
                                                $("#errorMsg").html(err.response.data.content);
                                                $(".alert-danger").removeClass("hide");
                                                $(".alert-danger").addClass("show");
                                                setTimeout(function () {
                                                    $(".alert-danger").removeClass("show");
                                                    $(".alert-danger").addClass("hide");
                                                }, 5000);
                                            }
                                        }
                                        self.hideLoader();
                                    });
                            /*$('#queueEmail').modal('hide');
                             self.$swal({
                             type: 'success',
                             text: 'Email notification sent successfully',
                             showConfirmButton: false,
                             timer: 5000,
                             });
                             self.loadHRTeam();*/
                        } else {
                            self.$swal('Cancelled', 'Your have canceled email notification', 'info')
                            $(e.target).text('Send Notification');
                            $(e.target).prop("disabled", false);
                            self.subject = '';
                            self.message = '';
                            self.filesAttachment = [];
                            $('#upload').val('');
                            $('#queueEmail').modal('hide');
                        }
                    });
                }
            },
            loadHRTeam: function () {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }

                if(self.serverParams.columnFilters.status == 'Active') {
                    self.serverParams.columnFilters.status = 1;
                } else if(self.serverParams.columnFilters.status == 'Deactive') {
                    self.serverParams.columnFilters.status = 0;
                }

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    /*messageData: self.message,*/
                    sort: self.serverParams.sort,
                    export_users: self.exportUsers
                };
                self.showLoader();
                HTTP.post('listuser', fields, config)
                        .then(function (response) {
                            $('#exportUsers').text('Export');
                            $('#exportUsers').prop("disabled", false);
                            if (response.data.message == "success export") {
                                location.href = response.data.content.web;
                            } else if (response.data.code == '200') {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                            }
                            self.exportUsers = false;

                            if(self.serverParams.columnFilters.status == 1) {
                                self.serverParams.columnFilters.status = 'Active';
                            } else if(self.serverParams.columnFilters.status.length != 0 && self.serverParams.columnFilters.status == 0) {
                                self.serverParams.columnFilters.status = 'Deactive';
                            }

                            self.hideLoader();
                        })
                        .catch(function (err) {
                            $('#exportUsers').text('Export');
                            $('#exportUsers').prop("disabled", false);
                            if (err.response.status == 0) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            }
                            self.exportUsers = false;
                            self.hideLoader();
                        })
            },
            exportUsersData: function () {
                self.exportUsers = true;
                if (self.exportUsers == true) {
                    $('#exportUsers').text('Exporting...');
                    $('#exportUsers').prop("disabled", true);
                    self.loadHRTeam();
                }
            },
            handleFilesUploadAttachment: function () {
                let uploadedFiles = "";
                uploadedFiles = self.$refs.filesAttachment.files;

                for (var i = 0; i < uploadedFiles.length; i++) {
                    self.filesAttachment = [uploadedFiles[i]];
                }
            },

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/user/ListUser.vue